module.exports = __webpack_public_path__ + "img/p4.0309706a.png";